import {_serializeSingle, _serializeList} from '../core';
import type {ServerData} from '../core';

/** 추출 데이터 */
export function serializeDocumentExtract(data: ServerData) {
    return _serializeSingle("documentInstanceExtract", data);
}

export function serializeDocumentExtractList(data: ServerData) {
    return _serializeList("documentInstanceExtract", data);
}
